import SEO from "../components/SEO";
import seoData from "../seoData";
import BreadcrumbSchema from "../components/BreadcrumbSchema";
import { Careers } from "../components/careers";
import JsonData from "../data/data.json";

const CareersPage = () => (
  <>
    {/* SEO Meta */}
    <SEO {...seoData.careers} />
    <BreadcrumbSchema
        items={[
            { name: "Home", url: "/" },
            { name: "Careers", url: "/careers" },
        ]}
    />
    <Careers data={JsonData.Careers} />
  </>
);

export default CareersPage;
